<template>
  <swiper id="home-swiper" :options="isMobile().any? swiperOptionMobile: swiperOptionPC" ref="homeSwiper" @slide-change-transition-start="updatePage" @slide-change-transition-end="updatedPage" :class="animationClass">
    <swiper-slide class="slider-item-1 h-100" :data-hash="'top'">
      <div v-if="isMobile().any" class="bg-mobile d-flex align-items-center">
        <img class="img-fluid" src="@/assets/images/top/bg@xs.jpg">
        <img class="arrow" src="@/assets/images/arrow-right-white.svg" @click="$refs.homeSwiper.$swiper.slideTo(1, 600, true)">
      </div>
      <div v-else class="bg-1-2">
        <img class="tissue-1" src="@/assets/images/top/tissue-1.png">
        <img class="tissue-2" src="@/assets/images/top/tissue-2.png">
        <img class="tissue-3" src="@/assets/images/top/tissue-3.png">
        <div class="arrows d-flex flex-column justify-content-around">
          <img src="@/assets/images/arrow-right-white.svg">
          <img src="@/assets/images/arrow-right-white.svg">
          <img src="@/assets/images/arrow-right-white.svg">
          <img src="@/assets/images/arrow-right-white.svg">
          <img src="@/assets/images/arrow-right-white.svg">
        </div>
        <div class="bg1" :style="{backgroundImage: 'url('+ bgImage(1, true) +')'}">
        </div>
        <div class="bg2" :style="{backgroundImage: 'url('+ bgImage(1, false) +')'}">
        </div>
        <div class="p-absolute w-100 h-100 d-flex justify-content-center align-items-center" style="top: 0; left: 0;">
          <img class="p-relative" src="@/assets/images/top/logo-2line-white.svg">
        </div>
      </div><!-- /.bg1-2 -->
      <div class="p-relative px-5 d-flex justify-content-center align-items-center h-100" style="pointer-events: none;">
        <img class="img-fluid" src="@/assets/images/top/logo-2line-white.svg">
      </div>
    </swiper-slide>
    <swiper-slide style="z-index:1;" :data-hash="'profile'">
      <div class="container container-uedahiraku h-100 text-white d-flex align-items-center">
        <div class="">
          <div class="row ">
            <div class="col-md-4 d-flex align-items-center justify-content-center mb-4">
              <div class="scroll-effect-slide-left" :class="profileIsShown? 'show':''">
                <h1 class="font-weight-bold">植田 楽</h1>
                <h6 class="font-weight-bold">（うえだひらく）</h6>
              </div>
            </div>
            <div class="col-md-8 scroll-effect-slide-left delay-3" :class="profileIsShown? 'show':''">
              <p class="h5 line-height-1_8">
                1993年京都生まれ。京都嵯峨美術大学現代アート領域専攻科卒。<br>
                約20年間、紙とセロハンテープで、主に動物や恐竜をモチーフに制作。
              </p>
              <p class="futura">
                Born in Kyoto in 1993. Graduated from Kyoto Saga Art University. Hiraku has been creating animals and dinosaurs out of paper and scotch tape for the last 20 years. 
              </p>
            </div>
          </div>
          <div class="text-center mt-4">
            <router-link :to="{name: 'exhibition', params: {pageNo: '1'}}" class="btn-goto-exhibition btn btn-outline-light d-inline-block scroll-effect-slide-left delay-6" :class="profileIsShown? 'show':''">
              EXHIBITIONS <font-awesome-icon icon="angle-down" class="ml-3" />
            </router-link>
          </div>
        </div>
      </div>
    </swiper-slide>
    <swiper-slide class="bg-white" :data-hash="'artwork'">
      <ArtWork ref="artwork" :rotationLv="rotationLv" @updateRotationLv="updateRotationLv" />
    </swiper-slide>
    <swiper-slide class="bg-white" :data-hash="'order'">
      <Order />
    </swiper-slide>
    <swiper-slide class="bg-white" :data-hash="'workshop'">
      <Workshop ref="workshop" />
    </swiper-slide>
    <swiper-slide class="bg-white" :data-hash="'contact'">
      <Contact />
    </swiper-slide>

  </swiper>
</template>

<script>
import isMobile from 'ismobilejs'
import bg1l from '@/assets/images/top/bg-l@2x.jpg'
import bg1r from '@/assets/images/top/bg-r@2x.jpg'
import bg1Mobile from '@/assets/images/top/bg-r.jpg'
import ArtWork from '@/components/ArtWork'
import Order from '@/components/Order'
import Workshop from '@/components/Workshop'
import Contact from '@/components/Contact'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'HomeSwiper',
  components: {
    ArtWork, Order, Workshop, Contact
  },
  props: {
    rotationLv: {
      type: String,
      default: '3'
    }
  },
  data() {
    return {
      isMobile,
      bg1l: bg1l,
      bg1r: bg1r,
      bg1Mobile: bg1Mobile,
      profileIsShown: false,
      isAnimating: false,
      swiperOptionPC: {
        direction: 'horizontal',
        slidesPerView: 1,
        speed: 600,
        spaceBetween: 0,
        simulateTouch:false,
        mousewheel: true,
        hashNavigation: {
          replaceState: true
        }
      },
      swiperOptionMobile: {
        direction: 'horizontal',
        slidesPerView: 1,
        speed: 600,
        spaceBetween: 0,
        mousewheel: false,
        hashNavigation: {
          replaceState: true
        }
      }
    }
  },
  mounted() {
    // console.log('isMobile? ' + this.isMobile().any)

   this.updatePage()
   this.updatedPage()
  },
  computed: {
    ...mapState({
      homeSwiperIndex: state => state.homeSwiperIndex,
      pageChanger: state => state.pageChanger
    }),
    animationClass() {
      if(this.isAnimating) {
        if (this.$refs.homeSwiper.$swiper.activeIndex > this.$refs.homeSwiper.$swiper.previousIndex) {
          return 'animating right';
        } else {
          return 'animating left';
        }
      } else {
        return ''
      }
    }
  },
  watch: {
    pageChanger () {
      // ルートの変更の検知...
      // console.log(from)
      if (location.hash == '#profile') {
        this.$refs.homeSwiper.$swiper.slideTo(1, 600, false)
      } else if (location.hash == '#top') {
        this.$refs.homeSwiper.$swiper.slideTo(0, 600, false)
      } else if (location.hash == '#artwork') {
        this.$refs.homeSwiper.$swiper.slideTo(2, 600, false)
      } else if (location.hash == '#order') {
        this.$refs.homeSwiper.$swiper.slideTo(3, 600, false)
      } else if (location.hash == '#workshop') {
        this.$refs.homeSwiper.$swiper.slideTo(4, 600, false)
      } else if (location.hash == '#contact') {
        this.$refs.homeSwiper.$swiper.slideTo(5, 600, false)
      }
      this.updatePage()
      this.updatedPage()
    }
  },
  methods: {
    bgImage(index, isLeft) {
      if (isLeft) {
        return bg1l
      } else {
        return bg1r
      }
    },
    updatePage() {
      this.isAnimating = true
      if (this.$refs.homeSwiper.$swiper.activeIndex == 0) {
        this.storePageControl({lightTheme: true, left: false, right: false, up: false, down: false})
      } else if (this.$refs.homeSwiper.$swiper.activeIndex == 1) {
        this.storePageControl({lightTheme: true, left: true, right: true, up: false, down: true})
      } else if (this.$refs.homeSwiper.$swiper.activeIndex == 2) {
        this.storePageControl({lightTheme: false, left: true, right: true, up: false, down: true})
      } else if (this.$refs.homeSwiper.$swiper.activeIndex == 3) {
        this.storePageControl({lightTheme: false, left: true, right: true, up: false, down: false})
      } else if (this.$refs.homeSwiper.$swiper.activeIndex == 4) {
        this.storePageControl({lightTheme: false, left: true, right: true, up: false, down: false})
      } else if (this.$refs.homeSwiper.$swiper.activeIndex == 5) {
        this.storePageControl({lightTheme: false, left: true, right: false, up: false, down: false})
      } 
      this.setHomeSwiperIndex(this.$refs.homeSwiper.$swiper.activeIndex)
    },
    ...mapActions({
      setHomeSwiperIndex: 'doSetHomeSwiperIndex',
      storePageControl: 'doSetPageControl',
      doUpdatePageChanger: 'doUpdatePageChanger'
    }),
    updateRotationLv(lv) {
      this.$emit('updateRotaionLv', lv)
    },
    updatedPage() {
      if(this.$refs.homeSwiper.$swiper.activeIndex == 1) {
        if (!this.profileIsShown) {
          this.profileIsShown = true
        }
      } else if(this.$refs.homeSwiper.$swiper.activeIndex == 2) {
        // console.log(this.$refs.artwork)
        if (this.$refs.artwork) {
          this.$refs.artwork.openingEffect()
        }
      }
      setTimeout(() => {
        this.isAnimating = false      
      }, 700);

    }
  }
}
</script>

<style lang="scss">
#home-swiper {
  height: 100%;
  .bg-mobile {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
    height: 100%;
    width: 200%;
    &:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.2);
    }
    .arrow {
      position: absolute;
      bottom: 20px;
      left: calc(100vw - 100px);
      z-index: 1;
    }
  }
  .bg-1-2 {
    display: none;
    @media screen and (min-width: 768px){
      display: block;
    }
    position: relative;
    width: 100%;
    height: 100%;
    .bg1 {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: right;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.1);
      } 
    }
    .bg2 {
      position: absolute;
      top: 0;
      left: 100%;
      width: 100%;
      height: 100%;
      background-size: cover;
      background-position: left;
      &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,0.1);
      } 
    }
  }
}
.tissue-1 {
  position: absolute;
  top: 0;
  left: calc(100vw - 500px);
  mix-blend-mode: multiply;
  z-index: 1;
  opacity: 0.8;
  pointer-events: none;
  transition: transform 2.0s;
  transform: translate(0px, 0px);
}
.tissue-2 {
  position: absolute;
  bottom: 0;
  left: -10px;
  mix-blend-mode: multiply;
  z-index: 1;
  opacity: 0.8;
  pointer-events: none;
  transition: transform 2.0s;
  transform: translate(0px, 0px);
}
.tissue-3 {
  position: absolute;
  bottom: -270px;
  left: calc(200vw - 300px);
  mix-blend-mode: multiply;
  z-index: 1;
  opacity: 0.8;
  pointer-events: none;
  transition: transform 2.0s;
  transform: translate(0px, 0px);
}
.bg1, .bg2 {
  transition: transform 3s;
  transform: translate(0px, 0px);
}
.swipe-0 {
  .bg1, .bg2 {
    transform: translate(-20px, 0px);
  }
  .tissue-1, .tissue-2, .tissue-3 {
    transform: translate(0px, 0px);
  }
}
.swipe-1 {
  .bg1, .bg2 {
    transform: translate(0px, 0px);
  }
  .tissue-1, .tissue-2, .tissue-3 {
    transform: translate(10px, 0px);
  }
}
.swipe-2 {
  .bg1, .bg2 {
    transform: translate(0px, 0px);
  }
  .tissue-3 {
    transform: translate(20px, 0px);
  }
}

.arrows {
  z-index: 1;
  position: absolute;
  top: 0;
  left: calc(100vw - 100px);
  height: 100%;
}
</style>

<style lang="scss" scoped>
.btn-goto-exhibition {
  // position: absolute;
  // bottom: 15px;
  // right: 15px;
  @media screen and (min-width: 768px){
    position: relative;
    bottom: inherit;
    right: inherit;
  }
}
</style>